import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { FlexBox } from '../../box';
import { ButtonBase } from '../../button';
import { getIcon } from '../../icon';
import { styled } from '../../styled';
import { Tooltip } from '../../tooltip';
import { TypographyWithTooltip } from '../../typography';
import { itemBackground } from '../shared';
export const MAIN_NAV_ITEM_SIZE = 36;
const AnimatedEntryContent = styled(FlexBox)(({ $collapsed, theme }) => ({
    gap: $collapsed ? 0 : theme.spacing(1),
    transition: theme.transitions.create('gap', {
        duration: theme.transitions.duration.standard,
        easing: theme.transitions.easing.easeInOut
    })
}));
const AnimatedIconText = styled(FlexBox)(({ $collapsed, theme }) => ({
    gap: $collapsed ? 0 : theme.spacing(1),
    transition: theme.transitions.create('gap', {
        duration: theme.transitions.duration.shorter,
        easing: theme.transitions.easing.easeInOut
    })
}));
const AnimatedText = styled(FlexBox)(({ $collapsed, theme }) => ({
    maxWidth: $collapsed ? 0 : 200,
    opacity: $collapsed ? 0 : 1,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    transition: theme.transitions.create(['max-width', 'opacity'], {
        duration: theme.transitions.duration.shorter,
        easing: theme.transitions.easing.easeInOut
    })
}));
const AnimatedBadge = styled(FlexBox)(({ $collapsed, theme }) => ({
    maxWidth: $collapsed ? 0 : 80,
    flexShrink: 0,
    opacity: $collapsed ? 0 : 1,
    overflow: 'hidden',
    transform: $collapsed ? 'translateX(-8px)' : 'translateX(0)',
    transition: theme.transitions.create(['max-width', 'opacity', 'transform'], {
        duration: theme.transitions.duration.shorter,
        easing: theme.transitions.easing.easeInOut
    })
}));
const NavButton = styled(ButtonBase)(({ $collapsed, theme }) => ({
    width: $collapsed ? MAIN_NAV_ITEM_SIZE : '100%',
    minWidth: $collapsed ? MAIN_NAV_ITEM_SIZE : undefined,
    height: MAIN_NAV_ITEM_SIZE,
    minHeight: MAIN_NAV_ITEM_SIZE,
    justifyContent: $collapsed ? 'center' : 'flex-start',
    padding: theme.spacing(1),
    borderRadius: theme.shape.borderRadius
}));
const MainNavItemImpl = (props) => {
    const Icon = props.icon ? getIcon(props.icon) : undefined;
    const color = props.selected ? 'primary.main' : 'text.primary';
    const collapsed = Boolean(props.collapsed);
    const mergedSx = [
        {
            backgroundColor: itemBackground(props.selected ? 'selected' : 'default'),
            '&:hover': {
                backgroundColor: props.selected
                    ? undefined
                    : itemBackground('hover')
            },
            '&:focus-visible': {
                backgroundColor: itemBackground('focus')
            }
        },
        props.buttonProps?.sx ?? {}
    ];
    return (_jsx(Tooltip, { title: collapsed ? (props.tooltip ?? props.label) : undefined, placement: "right", bypass: !collapsed, children: _jsx(NavButton, { "$collapsed": collapsed, ...props.buttonProps, "aria-current": props.selected ? 'page' : undefined, "data-role": props.dataRole ?? 'navigation-main-nav-item', onClick: (event) => {
                props.buttonProps?.onClick?.(event);
                props.onClick?.();
            }, sx: mergedSx, "data-role-value": props.dataRoleValue, children: _jsxs(AnimatedEntryContent, { "$collapsed": collapsed, hAlign: collapsed ? 'center' : 'space-between', vAlign: "center", width: "100%", children: [_jsxs(AnimatedIconText, { "$collapsed": collapsed, autoShrink: true, minWidth: 0, vAlign: "center", children: [Icon && (_jsx(Icon, { color: props.selected
                                    ? 'primary.main'
                                    : 'action.active', filled: props.selected, fontSize: "small" })), _jsx(AnimatedText, { "$collapsed": collapsed, children: _jsx(TypographyWithTooltip, { fontWeight: props.selected ? 500 : undefined, color: color, children: props.label }) })] }), props.badge && (_jsx(AnimatedBadge, { "$collapsed": collapsed, children: props.badge }))] }) }) }));
};
export const MainNavItem = MainNavItemImpl;
